import { CandidateFilterType } from '@pflegia/types/api/candidate/candidate-filter-type';
import { FilterValue } from '@pflegia/types/api/job-board/filter-value';

import { LoggedOutFilterType } from '@shared/enums/logged-out-filter-type.enum';

const POSITION_FILTER_TYPES: string[] = [CandidateFilterType.Position, LoggedOutFilterType.Position];

/** True when the given job title is the only filter set. */
export const isOnlyJobTitleFilter = (filters: FilterValue[], jobTitleId?: string): boolean => {
  if (!jobTitleId || filters.length !== 1) return false;

  const [filter] = filters;
  return POSITION_FILTER_TYPES.includes(filter.type) && filter.value === jobTitleId;
};
